module.exports = __webpack_public_path__ + "img/PL08642.dcaeae96.png";